<template>
    <div>
        <loading-card v-if="client == null || saving || deleting">
            <template v-if="saving">Enregistrement en cours ...</template>
            <template v-else-if="deleting">Suppression en cours ...</template>
            <template v-else>Chargement du client ...</template>
        </loading-card>
        <b-card title="Client" class="card-other" v-else>
            <validation-observer ref="simpleRules">
                <b-form>
                    <b-row>
                        <b-col lg="6" md="12">
                            <b-form-group label="Code Compta" label-for="codeCompta">
                                <validation-provider #default="{ errors }" name="Code Compta" rules="required">
                                    <b-form-input 
                                        v-model="codeCompta"
                                        id="codeCompta"
                                        placeholder="Code Compta"
                                        :state="errors.length > 0 ? false : null" 
                                    />
                                    <small class="text-danger">{{errors[0]}}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col lg="6" md="12">
                            <b-form-group label="Nom" label-for="nom">
                                <validation-provider #default="{ errors }" name="nom" rules="required">
                                    <b-form-input 
                                        v-model="nom"
                                        id="nom"
                                        placeholder="Nom"
                                        :state="errors.length > 0 ? false : null"
                                    />
                                    <small class="text-danger" v-if="errors.length > 0">{{errors[0]}}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="12" lg="6" md="8">
                            <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" to="/clients/list" class="mr-1">
                                <feather-icon icon="ListIcon" class="mr-50"/>
                                <span class="align-middle">Revenir à la liste</span>
                            </b-button>

                            <b-button variant="gradient-success" type="submit" @click.prevent="validationForm">
                                <feather-icon icon="CheckIcon" class="mr-50"/>
                                <span class="align-middle">{{creating ? "Ajouter" : "Enregistrer"}}</span>
                            </b-button>
                        </b-col>

                        <b-col sm="12" lg="6" md="4" :class="deleteClass" v-if="!creating">
                            <b-button variant="gradient-danger" @click="confirmDeleteClient(client.id, client.nom, goBack)">
                                <feather-icon icon="TrashIcon" class="mr-50"/>
                                <span class="align-middle">Supprimer</span>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </validation-observer>
        </b-card>
    </div>
</template>

<script>
    import LoadingCard from "@/views/GDLoadingCard"
    import clientApi from "@/api/clientApi"
    import {computedFactory} from "@/services/computedFactory"
    import { computed, ref } from '@vue/composition-api'
    import { confirmDeleteClient, deleteClient } from "@/views/setups/client"

    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import { required } from '@validations'

    import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
    
    export default {
        components: {
            LoadingCard,
            ValidationProvider,
            ValidationObserver,
            ToastificationContent
        },

        data() {
            return {
                saving: false,
                deleting: false,
            }
        },

        beforeMount() {
            if(this.$route.params.hasOwnProperty("clientId"))
                this.fetchClient();
        },

        setup(props, {root}) {
            const currentBreakPoint = computed(() => root.$store.getters['app/currentBreakPoint'])
            const expectedFields = ["codeCompta", "nom"];
            let clientBase = null;
            let creatingBase = !root.$route.params.hasOwnProperty("clientId");
            if(creatingBase)
                clientBase = expectedFields.reduce((accumulator, field) => ({...accumulator, [field]: ""}), {});

            const client = ref(clientBase);
            const creating = ref(creatingBase)
            return {
                client,
                creating,
                expectedFields,
                ...computedFactory(expectedFields, "client"),
                currentBreakPoint,
                required,
                confirmDeleteClient,
                deleteClient
            }
        },

        computed: {
            deleteClass() {
                return (this.currentBreakPoint == "sm" || this.currentBreakPoint == "xs") ? "mt-1" : "text-right";
            }
        },

        methods: {
            goBack() {
                // ! ATTENTION => fonctionne dans le cas retour à la liste. si on utilise le composant Client à un autre endroit
                // ! il faudra surement revoir la logique. a garder en tête.
                console.log("go back")
                this.$router.go(-1)
            },

            async fetchClient() {
                this.client = await clientApi.getClient(this.$route.params.clientId);
            },

            async validationForm() {
                let res = await this.$refs.simpleRules.validate()
                if(res)
                    this.save();
            },
            
            async save() {
                this.saving = true;
                let data = this.expectedFields.filter(field => this[field] != this.client[field]).reduce((accumulator, currentValue) => ({...accumulator, [currentValue]: this[currentValue]}), {});
                let callApi = this.creating ? () => clientApi.addClient(data) : () => clientApi.patchClient(this.client.id, data)
                try {
                    if(Object.entries(data).length != 0)
                        await callApi();
                    this.showToast("success", this.creating ? "Client créé" : "Client mis à jour", "CheckIcon")
                    this.$router.go(-1);
                } catch(e) {
                    console.log("e", e)
                    this.showToast("danger", "Une erreur s'est produite", "AlertCircleIcon")
                }
                finally {
                    this.saving = false;
                }
            },

            // TODO déplacer dans service, en faire une méthode générique
            showToast(variant, text, icon) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        icon,
                        text,
                        variant
                    },
                }, {position: "bottom-right", timeout: 2500})
            },
        }

    }
</script>